import RouteTemplate from 'ember-route-template';

import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';

import routesMatch from 'rise-ui/utils/routes-match.js';

export default class TimeSeriesIndexRoute extends Route {
  @service keywords;
  @service routeState;
  @service router;

  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords(
            true,
            this.keywords.strings['time-series-data-keywords'],
            this.keywords.strings['monitoring-data-keywords'],
            this.keywords.strings['modeled-data-keywords'],
            'query interface',
          ),
        },
      },
    ];
  }

  beforeModel(transition) {
    // Pass-through to default child route if routed directly to time-series index
    if (routesMatch(transition.to.name, this.routeName)) {
      this.router.replaceWith('time-series.search', {
        queryParams: this.routeState.deserializeAllQueryParams(transition.to),
      });
    }
  }
}
